'use es6';

import PropTypes from 'prop-types';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UIToggle from 'UIComponents/input/UIToggle';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { blogNewFeaturesTourSteps } from '../tourConstants';
import { BlogNewFeaturesTourStep } from '../components/BlogNewFeaturesTourStep';
import { useDismissStep } from '../hooks/tourHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const DistractionFreeToggle = ({
  isOpen,
  onChange,
  disabled,
  labelKey
}) => {
  const dismissStep = useDismissStep();
  return /*#__PURE__*/_jsx(BlogNewFeaturesTourStep, {
    stepKey: blogNewFeaturesTourSteps.TOUR_STEP_DISTRACTION_FREE,
    content: {
      header: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "focus.tour.header"
        })
      }),
      body: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "focus.tour.body"
        })
      }),
      footer: /*#__PURE__*/_jsx(UITourNextButton, {
        use: "primary",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "focus.tour.buttonText"
        })
      })
    },
    children: /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${labelKey}.toggleLabel`
      }),
      children: /*#__PURE__*/_jsx(UIToggle, {
        size: "small",
        checked: isOpen,
        disabled: disabled,
        onChange: ({
          target: {
            checked
          }
        }) => {
          dismissStep(blogNewFeaturesTourSteps.TOUR_STEP_DISTRACTION_FREE);
          onChange(checked);
          UsageTracker.track('toggleDistractionFree', {
            enabled: `${checked}`
          });
        },
        "data-test": "distractionfree-toggle"
      })
    })
  });
};
DistractionFreeToggle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelKey: PropTypes.string.isRequired
};
export default DistractionFreeToggle;